import { ReactNode } from 'react';
import appPlugin from '@backstage/plugin-app';
import { UnifiedThemeProvider } from '@backstage/theme';
import { createPortalTheme } from './portalTheme';

const portalTheme = createPortalTheme();

/**
 * Sobrescreve o tema claro embutido do Backstage (`theme:app/light`) para ser a
 * marca Grupo Hiper Saúde. Usa o mecanismo oficial de override do frontend
 * system: `appPlugin.getExtension('theme:app/light').override(...)`. Como o modo
 * claro é o padrão, a marca passa a valer automaticamente, sem o usuário
 * selecionar nada. O tema escuro embutido é preservado.
 */
export const portalLightThemeOverride = appPlugin
  .getExtension('theme:app/light')
  .override({
    params: {
      theme: {
        id: 'light',
        title: 'Grupo Hiper Saúde',
        variant: 'light',
        Provider: ({ children }: { children?: ReactNode }) => (
          <UnifiedThemeProvider theme={portalTheme}>
            {children}
          </UnifiedThemeProvider>
        ),
      },
    },
  });
